import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue"
import CreateTaskForm from "@/components/tasks/CreateTaskForm.vue"
import { Task } from "@/shared/models/task"
import { useWorkflowStore } from "@/stores/workflow"
import { deleteEmptyKeys } from "@/shared/utils/helpers"
import { ToastService } from "@/shared/services/toast"


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTaskSidebarComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const toastService = new ToastService()

const error = ref<{ field: string; message: string } | undefined>(undefined)

const taskUpdated = async (task: Task) => {
    try {
        const nonEmptyObj = deleteEmptyKeys(task)
        try {
            workflowStore.modelValue = nonEmptyObj
        } catch (error) {
            toastService.addToast({
                message: "Task update error",
                type: "error",
            })
        }

        if (!task.domainId) {
            error.value = {
                field: "domain",
                message: "Domain is required. Please select a domain.",
            }
            return
        }
    } catch (err: unknown) {
        error.value = { message: "Task update error", field: "" }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CreateTaskForm, {
    "onUpdate:task": taskUpdated,
    isForWorkflow: true,
    modalAction: 'someAction',
    taskId: 'someTaskId',
    isNotEditableByUser: true,
    errorValue: error.value
  }, null, 8, ["errorValue"]))
}
}

})